import { Button } from "../ui/button";
import {
  FileUploadList,
  FileUploadRoot,
  FileUploadTrigger,
} from "../ui/file-button";
import { HiUpload } from "react-icons/hi";

type FileUploadProps = {
  maxFiles: number;
  label: string;
  width?: string;
  onUpload: (file: File) => Promise<void>;
  files: File[];
};

const FileUploadComponent = ({
  maxFiles,
  label,
  onUpload,
  files,
}: FileUploadProps) => {
  // @ts-ignore
  const handleFileSelect = async (event: any) => {
    const files = event.acceptedFiles;
    if (!files || files.length === 0) return;

    for (const file of files) {
      try {
        await onUpload(file); // Call the custom upload function passed as a prop
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
  };
  // @ts-error
  return (
    <FileUploadRoot
      maxFiles={maxFiles}
      width={"full"}
      maxWidth={"28.5rem"}
      onFileChange={handleFileSelect}
    >
      <FileUploadTrigger asChild>
        <Button
          variant="outline"
          colorPalette={"gray"}
          width={"full"}
          backgroundColor={"#ffffff"}
          borderColor={"#334155"}
          borderWidth={"1px"}
          fontWeight={"600"}
          fontSize={"14px"}
          borderRadius={"0.5rem"}
          size="sm"
        >
          <HiUpload color={"black"} />
          <span className={"text-black text-[14px]"}>{label}</span>
          <input
            type="file"
            multiple
            onChange={handleFileSelect}
            style={{ display: "none" }}
          />
        </Button>
      </FileUploadTrigger>
      <FileUploadList files={files} showSize clearable />
    </FileUploadRoot>
  );
};

export default FileUploadComponent;
